module.exports = {"id":"134895","name":"Roberto Hilbert","rating":"73","photo":"./data/images/photos/1/134895.png","club":{"name":"Greuther Fürth","logo":"./data/images/clubs/GreutherFurth.png"},"positions":["DD","DLD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RobertoHilbert0.json
// module id = 3641
// module chunks = 0